import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: 13,
            '& .MuiAutocomplete-option': {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
                paddingTop: 0,
                paddingBottom: 0,
            },
            '& .MuiButton-outlined': {
                borderColor: 'divider',
            },
        },
        popper: {
            border: '1px solid rgba(27,31,35,.15)',
            boxShadow: '0 3px 12px rgba(27,31,35,.15)',
            width: 'auto',
            zIndex: 10,
            fontSize: 13,
            color: palette.grey[700],
            backgroundColor: theme.palette.background.default,
        },
        widePopper: {
            width: '22rem',
        },
        header: {
            borderBottom: `1px solid ${palette.divider}`,
            fontWeight: 600,
        },
        inputBase: {
            width: '100%',
            borderBottom: `1px solid ${palette.divider}`,

            '& .MuiSvgIcon-root': {
                marginRight: theme.spacing(2),
            },

            '& input': {
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(2),
                transition: theme.transitions.create(['border-color', 'box-shadow']),
                fontSize: 14,
                fontWeight: 500,
            },
        },
        paper: {
            color: palette.grey[700],
            fontSize: 13,
            borderRadius: 0,
        },
        option: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            paddingTop: 0,
            paddingBottom: 0,
            alignItems: 'center',
            fontWeight: 500,
            color: theme.palette.text.primary,
            margin: 0,
            '&[aria-selected="true"]': {
                backgroundColor: 'transparent',
            },
            '&[data-focus="true"]': {
                backgroundColor: theme.palette.action.hover,
            },
            '& .MuiChip-label': {
                fontSize: 12,
                fontWeight: 450,
            },
        },
        popperDisablePortal: {
            position: 'relative',
        },
        close: {
            opacity: 0.6,
            width: 18,
            height: 18,
        },
        item: {
            display: 'flex',
            flexDirection: 'row',
        },
    }))
